import React from 'react'
import PropTypes from 'prop-types'

import { appendPlaceholders } from '~/shared/utils'
import { useCurrentChannel } from '~/app/state/hooks'
import Comment from '~/modules/post/components/Comment'

import { List, ListItem } from './CommentList.styles'

const MIN_COMMENTS_COUNT = 10

/**
 *
 */
const CommentList = ({
  // @ts-expect-error TS(7031) FIXME: Binding element 'comments' implicitly has an 'any'... Remove this comment to see the full error message
  comments,
  // @ts-expect-error TS(7031) FIXME: Binding element 'selected' implicitly has an 'any'... Remove this comment to see the full error message
  selected,
  // @ts-expect-error TS(7031) FIXME: Binding element 'placeholder' implicitly has an 'a... Remove this comment to see the full error message
  placeholder,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onSelect' implicitly has an 'any'... Remove this comment to see the full error message
  onSelect,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onAddReply' implicitly has an 'an... Remove this comment to see the full error message
  onAddReply,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onDismiss' implicitly has an 'any... Remove this comment to see the full error message
  onDismiss,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onUnDismiss' implicitly has an 'a... Remove this comment to see the full error message
  onUnDismiss,
}) => {
  const { getCurrentChannel } = useCurrentChannel()
  const currentChannel = getCurrentChannel()

  let commentsToDisplay = comments || []
  if (placeholder) {
    commentsToDisplay = appendPlaceholders(comments, MIN_COMMENTS_COUNT)
  }

  if (!commentsToDisplay) {
    return null
  }

  return (
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    <List withPadding>
      {/* @ts-expect-error TS(7006) FIXME: Parameter 'comment' implicitly has an 'any' type. */}
      {commentsToDisplay.map((comment, index) => (
        <ListItem key={comment.id || index}>
          {comment.placeholder ? (
            // @ts-expect-error TS(2739) FIXME: Type '{ placeholder: any; }' is missing the follow... Remove this comment to see the full error message
            <Comment placeholder={comment.placeholder} />
          ) : (
            <Comment
              comment={comment}
              channel={currentChannel}
              selected={
                selected && selected.id === comment.id && comment.needsAttention
              }
              onSelect={onSelect}
              onAddReply={onAddReply}
              onDismiss={onDismiss}
              onUnDismiss={onUnDismiss}
            >
              {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
              <List oveflow>
                {/* @ts-expect-error TS(7006) FIXME: Parameter 'reply' implicitly has an 'any' type. */}
                {comment.replies.map((reply) => (
                  <ListItem key={reply.id}>
                    {/* @ts-expect-error TS(2741) FIXME: Property 'children' is missing in type '{ comment:... Remove this comment to see the full error message */}
                    <Comment
                      comment={reply}
                      channel={currentChannel}
                      selected={
                        selected &&
                        selected.id === reply.id &&
                        reply.needsAttention
                      }
                      onSelect={onSelect}
                      onAddReply={onAddReply}
                      onDismiss={onDismiss}
                      onUnDismiss={onUnDismiss}
                    />
                  </ListItem>
                ))}
              </List>
            </Comment>
          )}
        </ListItem>
      ))}
    </List>
  )
}

CommentList.propTypes = {
  comments: PropTypes.array,
  selected: PropTypes.object,
  placeholder: PropTypes.bool,
  onSelect: PropTypes.func,
  onAddReply: PropTypes.func,
  onDismiss: PropTypes.func,
  onUnDismiss: PropTypes.func,
}

CommentList.defaultProps = {
  comments: [],
  selected: null,
  placeholder: false,
  onSelect: () => {},
  onAddReply: () => {},
  onDismiss: () => {},
  onUnDismiss: () => {},
}

export default CommentList
